import { useEffect, useRef, useState } from 'react';
import * as OTPAuth from 'otpauth';

/**
 * Live TOTP hook — returns the current 6-digit code and remaining seconds.
 * Auto-refreshes every second. Returns ('', 0) when secret is missing/invalid.
 */
export default function useLiveTOTP(secret) {
  const [code, setCode] = useState('');
  const [remaining, setRemaining] = useState(0);
  const totpRef = useRef(null);

  useEffect(() => {
    if (!secret) { setCode(''); setRemaining(0); return; }
    try {
      const cleaned = String(secret).replace(/\s+/g, '').toUpperCase();
      totpRef.current = new OTPAuth.TOTP({
        issuer: 'AxialUp',
        label: 'Booking',
        algorithm: 'SHA1', digits: 6, period: 30,
        secret: OTPAuth.Secret.fromBase32(cleaned),
      });
    } catch (e) { setCode(''); return; }
    const tick = () => {
      try {
        setCode(totpRef.current.generate());
        setRemaining(30 - (Math.floor(Date.now() / 1000) % 30));
      } catch (e) { setCode(''); }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [secret]);

  return { code, remaining };
}
